var nybk = {
  back: [], 
  value:[],
  hulkapps_option: 0,
  flow_product: function(){
    set_timeout(2500);
    
    $('body').on('click', '.add-to-cart_custom', function(){
    	$('.show_addon_option').fadeIn();
      	$('body').addClass('show_popup');
        if($( window ).width()< 768){
          $('.addon_close.mobile_crose').show();
        }
        //set_timeout(0);
    });
    $('body').on('click', '.addon_close', function(){
    	$('.show_addon_option').fadeOut(); 
        $('body').removeClass('show_popup');
      	$(this).hasClass('mobile_crose').hide();
    });
    
     $('body').on('click', '.hulkapps_option .hulkapps_radio_option input', function(){
      
      
   $(this).closest('.hulkapps_option').find('.hul_next_btn').trigger('click');

     
     });
    
    $('body').on('click', '.next_btn_step', function(){
     
      $(this).closest('.hulkapps_option').find('.hul_next_btn').trigger('click');
    });
    
    $('body').on('click', '.hul_next_prev_btn .hul_next_btn', function(){
     
       
        var price = 0;
        var select_item=$(this).parent().closest(".hulkapps_option");
         
        var get_itemdata=$(select_item).find(".hulkapps_option_value");
     var heading = $.trim(select_item.find('.hulkapps_option_name').attr("aria-label"));
        if(heading == "PD" ){
              var checkprice= $(get_itemdata).find("input").data("price");
             var checkEmpty= $(select_item).find("input").val();
             if(checkEmpty !=""){
               search_select_value=checkEmpty;
              var select_value= $(search_select_value).val();
             }else{
               
                var select_value="";
             }
          
         
        }else{
            var checkprice= $(get_itemdata).find("input:checked").attr("data-price");
            var search_select_value= $(select_item).find("input:checked")[0];
             var select_value= $(search_select_value).val();
        }       
     
        var step = select_item.attr('data-step');
        price=checkprice;
       if(step == 1){
         empty_value();
         }
             add_value(step, select_value, heading, price);
        nybk.back.push(step);
        change_img(1);
      
      if(nybk.hulkapps_option == 6){

   
        // step 2
        if(step == 1){
          show_info();
           if(nybk.value[0].value =='Non-Prescription'){
              
              show_review();
           }else{
            
             if(nybk.value[0].value == 'Readers'){
               $('.hulkapps_option_set .hulkapps_option[data-step="3"]').fadeToggle();
               add_subtotal(3);
                select_item.hide();
             }else{
             	$('.hulkapps_option_set .hulkapps_option[data-step="2"]').fadeToggle(); 
               add_subtotal(2);
             }
             
           }
          // step 2
        } else if(step == 2){
          
             $('.hulkapps_option_set .hulkapps_option[data-step="4"]').fadeToggle().find('.step_subtotal').hide();
             $('.hulkapps_option_set .hulkapps_option[data-step="5"]').fadeToggle().find('.step_subtotal').hide();
             add_next_btn(5);
             select_item.hide(); 
           // step 3	
         }else{
           show_review();
         } 
        
      }else{
        // step 1
      if(step == 1){

          show_info();
          add_subtotal(2);
       
        
        $('.hulkapps_option_set .hulkapps_option[data-step="2"]').fadeToggle();   
          select_item.hide();
        // step 2
       }else if(step == 2){
          
         if(nybk.value[0].value == 'Readers'){
           
            $('.hulkapps_option_set .hulkapps_option[data-step="5"]').fadeToggle().find('.step_subtotal').hide();
            $('.hulkapps_option_set .hulkapps_option[data-step="4"]').fadeToggle().find('.step_subtotal').hide();
          
            add_next_btn(5);
            select_item.hide(); 
         }else if(nybk.value[0].value =='Non-Prescription'){
             add_value(step, select_value, heading, price);
           show_review();
           console.log("show review step");
         }else{
 		   $('.hulkapps_option_set .hulkapps_option[data-step="3"]').fadeToggle();            
           add_subtotal(3);
              select_item.hide(); 
         }
        // step 3 
        }else if(step == 3){
      
            $('.hulkapps_option_set .hulkapps_option[data-step="5"]').fadeToggle().find('.step_subtotal').hide();
            $('.hulkapps_option_set .hulkapps_option[data-step="4"]').fadeToggle().find('.step_subtotal').hide();
            add_next_btn(5);
                select_item.hide(); 
       }else{
         show_review();
       } 
      }
      
      /*
      else if(step == 3){
         select_item.slideToggle();
         if(nybk.value[0].value == 'Readers' || nybk.value[0].value =='Non-Prescription'){ 
         	$('.hulkapps_option_set .hulkapps_option[data-step="5"]').slideToggle();  
         }else{
           $('.hulkapps_option_set .hulkapps_option[data-step="4"]').slideToggle(); 
         }                  
       }
       */
      
    });
    
    function show_info(){
      $('.class_lens').hide(); 
      
      if(nybk.value[0].value == 'Readers'){
        $('.choose__readers').show();        
      }else if(nybk.value[0].value =='Non-Prescription'){
        $('.choose__non_pre').show();
      }else if(nybk.value[0].value =='Prescription'){
         $('.choose__pre').show();
      }
    }
    
    function add_next_btn(that){
      var add_btn =  $('.hulkapps_option_set .hulkapps_option[data-step="'+that+'"]');
      if(add_btn.find('.next_btn_step').length == 0){
      	add_btn.append('<div class="next_btn_step">Next step</div>');
        add_btn.find('input[type="text"]').addClass('input_helf').attr('placeholder', 'PD ex)59');
        add_btn.append("<div class='bottom_txt_inner'>If you don't know your pupil distance, you can measure it with a simple PD measuring app such as EyeMeasure. If you are in need of assistance, email info@shopmegane.com <a target='_blank' href='//shopmegane.com/cdn/shop/t/14/assets/NYBK-Optical-PD-Ruler.pdf?v=2114'>here</a></div>");
      }
    }
    
    function change_img(next_prev){
       var url = $('.show_addon_image img').attr('src');       
       var count = parseInt($('.show_addon_image').attr('data-count'));
       var current_count = 0;
      for(var i = 1; i<= count; i++){
         var url_img = $('.show_addon_image').attr('data-val_'+i);
        if(url_img == url){            
           current_count = i;
        }
      }
      
      if(next_prev){
        current_count ++;
      }else{
        current_count --;
      }
       url_img = $('.show_addon_image').attr('data-val_'+current_count);      
       if(typeof url_img != 'undefined'){
       		$('.show_addon_image img').attr('src', url_img);
    	}
    }
    
    function show_review(){
      	
         printReview();
       $('.hulkapps_box').hide();
 //as        $('.review_page').slideToggle().toggleClass('active');
      	$('.review_page').fadeToggle().toggleClass('active');
    }
    
    $('body').on('click', '.hul_next_prev_btn .hul_prev_btn', function(){
       change_img(0);
      var lastEl = nybk.back.slice(-1)[0];         
      if($(this).closest('.hul_next_prev_btn').hasClass('review_page_nxpv')){
        $('.review_page').removeClass('active').hide();
        $('.hulkapps_box').fadeToggle();
       
        nybk.back.splice(-1,1);
      }else{        
        if(lastEl !=undefined){
          $(this).closest('.hulkapps_option').hide();         
          $('.hulkapps_option[data-step="'+lastEl+'"]').fadeToggle();  
          if(lastEl == 2 || lastEl == 3){
            $('.hulkapps_option_set .hulkapps_option[data-step="4"]').hide(); 
          }
          nybk.back.splice(-1,1);
        }
      } 
        
    });
    
    function add_value(id, select_value, heading, price){
      $(nybk.value).each(function(index, val){
        if(id == val.id){
          val.value = select_value;
          val.heading = heading;
          val.price = price;
        }
      }); 
    }
    function empty_value(){
      $(nybk.value).each(function(index, val){
          val.value = '';
          val.heading = '';
          val.price = '';
      });
    }
    
    function set_timeout(time){
      setTimeout(function(){
        var step = 1;
        nybk.value.length = 0;
         var moneyFormat = theme.moneyFormat;
         var price = $('.review_page button .buttonPrice').attr('data-item-price');
        console.log(price);
         nybk.hulkapps_option = $('.hulkapps_option_set .hulkapps_option').length;
         
        
        
        $('.hulkapps_option_set .hulkapps_option').each(function(){     
            nybk.value.push({'id': step, 'value': '', 'heading': '', 'price': ''});
          
           /*
          	var top_txt = $(this).find('.hulkapps_helptext').html();
            $(this).find('.hulkapps_helptext').html('');
            if(top_txt != '' && top_txt != undefined){
               $(this).append('<div class="bottom_txt_hlf">'+top_txt+'</div>');
            }
            */
          
            $(this).append('<div class="hul_next_prev_btn"><span class="hul_prev_btn hul_npx_btn">prev</span><span class="hul_next_btn hul_npx_btn">next</span></div>');
          	$(this).attr('data-step', step);
          	 step++;  
            // subtotal
           
            $(this).append('<div class="step_subtotal"><span class="step_subtotal_txt">Subtotal</span><spna class="step_subtotal_price">'+price+'</span></div>');
             $(this).find('.step_subtotal_price').html(Shopify.formatMoney(price, moneyFormat));
          });
        
        add_subtext();
      },time);
    }
    
    function add_subtotal(that){
      var total_price =  $('.review_page button .buttonPrice').attr('data-item-price')/100;
      var moneyFormat = theme.moneyFormat;
      
      $(nybk.value).each(function(index, val){ 
         if(val.price != '' && val.price !=0 && val.price != '0.00' ){
                total_price +=parseInt(val.price);
              }
      });
      
      
      $('.hulkapps_option[data-step="'+that+'"] .step_subtotal_price').html(Shopify.formatMoney(total_price*100, moneyFormat));
    }
    
    function add_subtext(){
      var class_txt = "Basic lens with anti-reflective coatings.";
      var blue_light = "Blue light filter/coating that blocks harmful blue light from digital screens.";
      var light_responsive = "Lens that transitions from clear indoors to a darker shade when exposed to UV/sunlight. This lens also filters blue-light.";
      var polycarbonate = "All lenses are made of high-quality materials and are built to last.";
      var basic_polycarbonate = "All lenses are made of high-quality materials and are built to last. Polycarbonate lenses are recommended for prescriptions of +/- 3.00. and below";
      var highIndex = "Thinner and lighter lenses recommended for strong prescriptions of +/-4.00 SPH and above.";
      var nonPrescription = "Customizations available for eye protection with no vision correction or magnification.";
      var PrescriptionBasic = "Single-vision prescription lenses: corrects either near/distance vision.";
      var readers = "Simple magnification for everyday use.";
      var pupilDistance = "Insert your Pupil Distance";
      var prescription = "Please upload a copy of your prescription.";  
      var high_choose_1_pre = "with scratch &amp; smudge resistant anti-reflective coatings that block UV rays.";
      var high_choose_1_non_pre = "with scratch &amp; smudge resistant anti-reflective coatings that block UV rays.";
      var high_choose_1_readers = "with scratch &amp; smudge resistant anti-reflective coatings that block UV rays.";
      
      var high_choose_2 = "with scratch &amp; smudge resistant anti-reflective coatings that block UV rays.";
      var high_choose_3 = "with scratch &amp; smudge resistant anti-reflective coatings that block UV rays.";       
      var type = 3;
      
      var readers_classic = "Simple magnification for everyday use.";
      
      if(nybk.hulkapps_option == 6 ){
         type = 2;
      }
      
      $('.hulkapps_option_set .hulkapps_option[data-step="'+type+'"] .hulkapps_option_value .hulkapps_radio_option:nth-child(1)').append('<div class="sub_txt_addon">'+class_txt+'</div>');
      $('.hulkapps_option_set .hulkapps_option[data-step="'+type+'"] .hulkapps_option_value .hulkapps_radio_option:nth-child(2)').append('<div class="sub_txt_addon">'+blue_light+'</div>');
      $('.hulkapps_option_set .hulkapps_option[data-step="'+type+'"] .hulkapps_option_value .hulkapps_radio_option:nth-child(3)').append('<div class="sub_txt_addon">'+light_responsive+'</div>');
     
      if(type != 2){
        $('.hulkapps_option_set .hulkapps_option[data-step="2"] .hulkapps_option_value .hulkapps_radio_option:nth-child(1)').append('<div class="sub_txt_addon"><span class="class_lens choose__pre">'+high_choose_1_pre+'</span><span class="class_lens choose__non_pre">'+ high_choose_1_non_pre+'</span><span class="class_lens choose__readers">'+high_choose_1_readers+'</span></div>');
        $('.hulkapps_option_set .hulkapps_option[data-step="2"] .hulkapps_option_value .hulkapps_radio_option:nth-child(2)').append('<div class="sub_txt_addon">'+high_choose_2+'</div>');
        $('.hulkapps_option_set .hulkapps_option[data-step="2"] .hulkapps_option_value .hulkapps_radio_option:nth-child(3)').append('<div class="sub_txt_addon">'+high_choose_3+'</div>');
      }else{
        $('.hulkapps_option_set .hulkapps_option[data-step="3"] .hulkapps_option_value').append('<div class="sub_txt_addon">'+readers_classic+'</div>');
      }
      
      $('.hulkapps_option_set .hulkapps_option[data-step="1"] .hulkapps_option_value .hulkapps_radio_option:nth-child(1)').append('<div class="sub_txt_addon">'+nonPrescription+'</div>');
      $('.hulkapps_option_set .hulkapps_option[data-step="1"] .hulkapps_option_value .hulkapps_radio_option:nth-child(2)').append('<div class="sub_txt_addon">'+PrescriptionBasic+'</div>');
      $('.hulkapps_option_set .hulkapps_option[data-step="1"] .hulkapps_option_value .hulkapps_radio_option:nth-child(3)').append('<div class="sub_txt_addon">'+readers+'</div>');
     
        $('.hulkapps_option_set .hulkapps_option[data-step="4"] .hulkapps_option_value').append('<div class="sub_txt_addon">'+prescription+'</div>');
        $('.hulkapps_option_set .hulkapps_option[data-step="5"] .hulkapps_option_value').append('<div class="sub_txt_addon">'+pupilDistance+'</div>');
  
      //$('.hulkapps_option_set .hulkapps_option[data-step="6"] .hulkapps_option_value .hulkapps_radio_option:nth-child(4)').append('<div class="sub_txt_addon">'+high_choose_4+'</div>');
      //$('.hulkapps_option_set .hulkapps_option[data-step="6"] .hulkapps_option_value .hulkapps_radio_option:nth-child(5)').append('<div class="sub_txt_addon">'+high_choose_5+'</div>');
      
       // $('.hulkapps_option_set .hulkapps_option[data-step="3"] .hulkapps_option_value .hulkapps_radio_option:nth-child(4)').append('<div class="sub_txt_addon">'+lens_type_4+'</div>');
       // $('.hulkapps_option_set .hulkapps_option[data-step="3"] .hulkapps_option_value .hulkapps_radio_option:nth-child(5)').append('<div class="sub_txt_addon">'+lens_type_5+'</div>');
      
       // $('.hulkapps_option_set .hulkapps_option[data-step="5"] .hulkapps_option_value .hulkapps_radio_option').append('<div class="sub_txt_addon">'+polycarbonate+'</div>');
      
       
    }
    
    function printReview(){
      var review = ''
      var total_price =0;     
      var moneyFormat = theme.moneyFormat;
       $(nybk.value).each(function(index, val){         
        review += '<div class="review_option">'; 
       
        if(val.value != '' ){ 

          review += '<div class="review_val  hello"><h4>'+val.heading +'</h4>'+ val.value +'</div>';          
        
          
        
              if(val.price != '' && val.price !=0 && val.price != '0.00' ){  
                review += '<div class="review_price money">$'+val.price +'</div>';  
                total_price +=parseInt(val.price);
              }else{
                review += '<div class="review_price money"> Free  </div>';
              }
          }
        review +='</div>'; 

   
         
       }); 
      
        var price = $('.review_page button .buttonPrice').attr('data-item-price')/100;
      	total_price +=price;
        $('.review_page .buttonPrice').attr("data-item-price",total_price*100);      
        $('.review_page .buttonPrice').html(Shopify.formatMoney(total_price*100, moneyFormat));
        $('.review_result').html(review);
    }
    
  },
  
  
  redirect_website: function(){
    
     $.get("https://ipinfo.io", function(response) {    	 
      if(response.country == 'KR'){
        window.location.href = "https://www.nybkusa.co.kr/";
      }else{
        $('body').show();
      }
    }, "jsonp");
    
  },
  menu_option: function(){
    $('body').on('click', '.main-menu .drop_down_menu', function(e){
    	e.preventDefault();
      if($(this).parent('li').hasClass('active')){
         $(this).parent('li').removeClass('active'); 
         $('main').removeClass('active');
         $('body').removeClass('active_hidden');        
      }else{       
        $('.main-menu li').removeClass('active');
        $(this).parent('li').addClass('active');
        $('main').addClass('active');
        $('body').addClass('active_hidden');
      }
      
    });
    
    $('body').on('click', 'main', function(){
      	$(this).removeClass('active');
        $('body').removeClass('active_hidden');
       $('.main-menu li').removeClass('active');
    });
        
  },
  custome_addtocart: function(){
    $('body').on('click', '.adpct_addtocart', function(){
       var id = $(this).attr('data-pd');
      if($(this).hasClass('active')){           
        remove_cart(id);       
      }else{
         addtocart(id);               
      }
      
    });
    
    function addtocart(id){
         $.ajax({
              type: 'POST', 
              url: '/cart/add.js',
              dataType: 'json', 
              data: {id:id,quantity:1},
              success: function(){ 
                   window.location.href = "/cart";
                }
   		});
    }
    
    function remove_cart(id){
       
      
       jQuery.post('/cart/update.js', 'updates['+id+']=0');
      setTimeout(function(){
    	  window.location.href = "/cart";
      },600);
         
    }
    
  }
  
  
}

$(function(){
  
});


$(document).ready(function(){
   nybk.flow_product();
 //  nybk.redirect_website();
  
  nybk.menu_option();
  nybk.custome_addtocart();
  
  $('.megaMenuCloseBtn').click(function(){
  	$('.main-menu li').removeClass('active');
  });
});
    
    